import styled from "styled-components";

const H1 = styled.h1`
  font-size: 25px !important;
  font-weight: 800 !important;
  margin-bottom: 5px;
  text-transform: uppercase
`;
export default H1;
